import { render } from "./ControlFileUpload.vue?vue&type=template&id=587850da&scoped=true&ts=true&lang=pug"
import script from "./ControlFileUpload.vue?vue&type=script&lang=ts"
export * from "./ControlFileUpload.vue?vue&type=script&lang=ts"

import "./ControlFileUpload.vue?vue&type=style&index=0&id=587850da&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587850da"]])

export default __exports__